(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-bf-garland-configurator]');
  Array.prototype.forEach.call(roots, initializeConfigurator);
  document.addEventListener('click', handleGroupedRemoval, true);

  function initializeConfigurator(root) {
    if (!root || root.getAttribute('data-bf-ready') === 'true') return;
    root.setAttribute('data-bf-ready', 'true');

    var dataNode = root.querySelector('[data-bf-garland-data]');
    var linesNode = root.querySelector('[data-bf-garland-lines]');
    if (!dataNode || !linesNode) return;

    var config;
    try {
      config = JSON.parse(dataNode.textContent || '{}');
    } catch (error) {
      return;
    }
    if (!config.styles || !config.styles.length || !config.prices || !config.multiPrices) return;

    var context = root.getAttribute('data-bf-context') || 'builder';
    var state = {
      lines: [],
      recommendedDelivery: '',
      deliveryTouched: false,
      calendarMonth: null,
      existingEligibleSubtotal: 0
    };
    var addButton = root.querySelector('[data-bf-add-garland]');
    var submitButton = root.querySelector('[data-bf-submit]');
    var eventInput = root.querySelector('[data-bf-event-date]');
    var deliveryInput = root.querySelector('[data-bf-delivery-date]');
    var earliestButton = root.querySelector('[data-bf-use-earliest]');
    var recommendationButton = root.querySelector('[data-bf-use-recommended]');
    var earliestLabel = root.querySelector('[data-bf-earliest-label]');
    var recommendationLabel = root.querySelector('[data-bf-recommended-label]');
    var calendarNode = root.querySelector('[data-bf-calendar]');
    var deliveryHelp = root.querySelector('[data-bf-delivery-help]');
    var statusNode = root.querySelector('[data-bf-status]');
    var minimumNode = root.querySelector('[data-bf-minimum-status]');
    var limitNode = root.querySelector('[data-bf-limit-status]');

    function money(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents || 0) / 100);
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[character];
      });
    }

    function styleByHandle(handle) {
      return config.styles.find(function (style) { return style.handle === handle; });
    }

    function lineId() {
      return 'garland-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
    }

    function requestedGarlandHandle() {
      if (config.initialHandle && styleByHandle(config.initialHandle)) return config.initialHandle;
      try {
        var requested = new URLSearchParams(window.location.search).get('garland') || '';
        return styleByHandle(requested) ? requested : '';
      } catch (error) {
        return '';
      }
    }

    function lengthOptions(selectedLength, line) {
      var html = '<option value="">Select length and price</option>';
      var index = line ? state.lines.findIndex(function (entry) { return entry.id === line.id; }) : 0;
      for (var length = Number(config.minimumLength); length <= Number(config.maximumLength); length += 1) {
        var pricing = linePricing(index, length, line ? line.pieces : 1);
        var disabled = !pricing.available ? ' disabled' : '';
        var priceCopy = '';
        if (!pricing.available) {
          priceCopy = ' - exceeds ' + config.maximumLength + ' total ft';
        } else if (index > 0) {
          priceCopy = ' - add ' + money(pricing.added) + ' - regular ' + money(pricing.regular) + ' - save ' + money(pricing.savings);
        } else {
          priceCopy = ' - ' + money(pricing.added);
        }
        html += '<option value="' + length + '"' + (Number(selectedLength) === length ? ' selected' : '') + disabled + '>' + length + ' ft' + priceCopy + '</option>';
      }
      return html;
    }

    function styleOptions(selectedHandle) {
      return config.styles.map(function (style) {
        return '<option value="' + escapeHtml(style.handle) + '"' + (style.handle === selectedHandle ? ' selected' : '') + '>' + escapeHtml(style.title) + '</option>';
      }).join('');
    }

    function addLine(seed) {
      var values = seed || {};
      var handle = values.handle || config.styles[0].handle;
      var line = {
        id: lineId(),
        handle: handle,
        length: Number(values.length) || 0,
        pieces: Math.max(1, Math.floor(Number(values.pieces) || 1)),
        locked: Boolean(values.locked)
      };
      state.lines.push(line);

      var selectedStyle = styleByHandle(line.handle) || config.styles[0];
      var wrapper = document.createElement('div');
      wrapper.className = 'bf-garland-line';
      wrapper.setAttribute('data-bf-garland-line', line.id);
      wrapper.innerHTML =
        '<div class="bf-garland-line__media">' +
          '<img class="bf-garland-line__image" src="' + escapeHtml(selectedStyle.image) + '" alt="' + escapeHtml(selectedStyle.fullTitle) + '" width="96" height="96" loading="lazy" data-bf-line-image>' +
          '<span class="bf-garland-line__number" data-bf-line-number></span>' +
        '</div>' +
        '<div class="bf-garland-line__controls">' +
          '<div class="bf-garland-line__field bf-garland-line__field--style">' +
            '<label>Garland variety</label>' +
            (line.locked
              ? '<div class="bf-garland-line__fixed-style">' + escapeHtml(selectedStyle.title) + '</div>'
              : '<select data-bf-line-style>' + styleOptions(line.handle) + '</select>') +
          '</div>' +
          '<div class="bf-garland-line__field">' +
            '<label>Length and price</label>' +
            '<select data-bf-line-length>' + lengthOptions(line.length, line) + '</select>' +
            '<div class="bf-garland-line__selected-price" data-bf-line-selected-price hidden aria-live="polite">' +
              '<div class="bf-garland-line__selected-price-main">' +
                '<span data-bf-line-selected-price-label></span>' +
                '<strong data-bf-line-selected-price-value></strong>' +
              '</div>' +
              '<div class="bf-garland-line__comparison" data-bf-line-comparison hidden>' +
                '<span>Regular <s data-bf-line-regular-price></s></span>' +
                '<strong data-bf-line-savings></strong>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="bf-garland-line__field">' +
            '<label>Quantity</label>' +
            '<input type="number" min="1" max="99" step="1" inputmode="numeric" value="' + line.pieces + '" data-bf-line-pieces>' +
          '</div>' +
          (!line.locked ? '<button type="button" class="bf-garland-line__remove" data-bf-remove-line>Remove</button>' : '<span aria-hidden="true"></span>') +
          '<small class="bf-garland-line__impact" data-bf-line-impact></small>' +
        '</div>';
      linesNode.appendChild(wrapper);
      renumberLines();
      render();
    }

    function renumberLines() {
      Array.prototype.forEach.call(linesNode.querySelectorAll('[data-bf-line-number]'), function (node, index) {
        node.textContent = 'Garland ' + (index + 1);
      });
    }

    function updateLineImage(line, wrapper) {
      var style = styleByHandle(line.handle) || config.styles[0];
      var image = wrapper && wrapper.querySelector('[data-bf-line-image]');
      if (!image || !style) return;
      image.src = style.image;
      image.alt = style.fullTitle;
    }

    function readLine(target) {
      var wrapper = target.closest('[data-bf-garland-line]');
      if (!wrapper) return null;
      return state.lines.find(function (line) {
        return line.id === wrapper.getAttribute('data-bf-garland-line');
      });
    }

    function validLine(line) {
      return Number.isInteger(line.length) && line.length >= Number(config.minimumLength) && line.length <= Number(config.maximumLength) && Number.isInteger(line.pieces) && line.pieces >= 1;
    }

    function summaryFor(lines) {
      var validLines = (lines || []).filter(validLine);
      var totalFeet = validLines.reduce(function (sum, line) { return sum + (line.length * line.pieces); }, 0);
      var totalGarlands = validLines.reduce(function (sum, line) { return sum + line.pieces; }, 0);
      var priceMap = totalGarlands > 1 ? config.multiPrices : config.prices;
      var priceRecord = priceMap[String(totalFeet)] || null;
      var basePrice = priceRecord ? Number(priceRecord.price) : 0;
      var subtotal = basePrice;
      var separateTotal = validLines.reduce(function (sum, line) {
        var singlePrice = config.prices[String(line.length)];
        return sum + (singlePrice ? Number(singlePrice.price) * line.pieces : 0);
      }, 0);
      return {
        totalFeet: totalFeet,
        totalGarlands: totalGarlands,
        priceRecord: priceRecord,
        basePrice: basePrice,
        additionalGarlandCount: Math.max(0, totalGarlands - 1),
        additionalGarlandTotal: 0,
        subtotal: subtotal,
        savings: Math.max(0, separateTotal - subtotal),
        allLinesValid: validLines.length === state.lines.length && state.lines.length > 0,
        withinMaximum: totalFeet <= Number(config.maximumLength)
      };
    }

    function linePricing(index, length, pieces) {
      var regularRecord = config.prices[String(length)] || null;
      var previousLines = state.lines.slice(0, Math.max(0, index));
      var candidate = Object.assign({}, state.lines[index] || {}, {
        length: Number(length) || 0,
        pieces: Math.max(1, Math.floor(Number(pieces) || 1))
      });
      var before = summaryFor(previousLines);
      var after = summaryFor(previousLines.concat([candidate]));
      var regular = regularRecord ? Number(regularRecord.price) * candidate.pieces : 0;
      var available = Boolean(regularRecord && after.priceRecord && after.withinMaximum);
      var added = available ? Math.max(0, after.subtotal - before.subtotal) : 0;
      return {
        available: available,
        added: added,
        regular: regular,
        savings: available ? Math.max(0, regular - added) : 0
      };
    }

    function refreshLengthOptions() {
      state.lines.forEach(function (line) {
        var wrapper = linesNode.querySelector('[data-bf-garland-line="' + line.id + '"]');
        var select = wrapper && wrapper.querySelector('[data-bf-line-length]');
        if (select) select.innerHTML = lengthOptions(line.length, line);
      });
    }

    function renderLineImpacts(summary) {
      state.lines.forEach(function (line, index) {
        var wrapper = linesNode.querySelector('[data-bf-garland-line="' + line.id + '"]');
        var impact = wrapper && wrapper.querySelector('[data-bf-line-impact]');
        var selectedPrice = wrapper && wrapper.querySelector('[data-bf-line-selected-price]');
        var selectedPriceLabel = wrapper && wrapper.querySelector('[data-bf-line-selected-price-label]');
        var selectedPriceValue = wrapper && wrapper.querySelector('[data-bf-line-selected-price-value]');
        var comparison = wrapper && wrapper.querySelector('[data-bf-line-comparison]');
        var regularPrice = wrapper && wrapper.querySelector('[data-bf-line-regular-price]');
        var savings = wrapper && wrapper.querySelector('[data-bf-line-savings]');
        var pricing = linePricing(index, line.length, line.pieces);
        if (selectedPrice) {
          selectedPrice.hidden = !validLine(line) || !pricing.available;
          if (!selectedPrice.hidden) {
            selectedPriceLabel.textContent = index > 0
              ? (line.pieces > 1 ? 'Additional garlands (' + line.pieces + ')' : 'Additional garland')
              : (line.pieces > 1 ? line.pieces + ' garlands' : 'One ' + line.length + ' ft garland');
            selectedPriceValue.textContent = money(pricing.added);
            comparison.hidden = pricing.savings === 0;
            if (!comparison.hidden) {
              regularPrice.textContent = money(pricing.regular);
              savings.textContent = 'Save ' + money(pricing.savings);
            }
          }
        }
        if (!impact) return;
        if (!validLine(line)) {
          impact.textContent = 'Select a whole-foot length from ' + config.minimumLength + ' to ' + config.maximumLength + ' feet.';
        } else if (!summary.withinMaximum) {
          impact.textContent = 'This configuration is over ' + config.maximumLength + ' total feet.';
        } else {
          impact.textContent = '';
        }
      });
    }

    function renderSummaryLines(summary) {
      var node = root.querySelector('[data-bf-summary-lines]');
      if (!node) return;
      node.innerHTML = state.lines.map(function (line, index) {
        var style = styleByHandle(line.handle);
        var lengthCopy = validLine(line) ? line.length + ' ft x ' + line.pieces : 'Select a length';
        var amount = validLine(line) && summary.withinMaximum ? linePricing(index, line.length, line.pieces).added : 0;
        return '<p class="bf-garland-configurator__summary-line">' +
          '<img class="bf-garland-configurator__summary-image" src="' + escapeHtml(style ? style.image : '') + '" alt="" width="40" height="40" loading="lazy">' +
          '<span>Garland ' + (index + 1) + ': ' + escapeHtml(style ? style.title : 'Fresh garland') + '<br>' + escapeHtml(lengthCopy) + '</span>' +
          '<strong>' + (amount ? money(amount) : '-') + '</strong>' +
        '</p>';
      }).join('');
    }

    function isMinimumEligibleItem(item) {
      if (item && item.properties && String(item.properties._bf_custom_garland) === 'true') return true;
      var handle = String(item && (item.handle || item.product_handle) || '').toLowerCase();
      var title = String(item && (item.product_title || item.title) || '').toLowerCase();
      var vendor = String(item && item.vendor || '').toLowerCase();
      var type = String(item && item.product_type || '').toLowerCase();
      if (/fee/.test(handle) || /fee/.test(title)) return false;
      return /^fresh[-_]/.test(handle) || /^fresh\b/.test(title) || /fresh/.test(vendor) || /fresh/.test(type) || /garland/.test(handle) || /garland/.test(title);
    }

    function loadExistingEligibleSubtotal() {
      var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      return fetch(rootUrl + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('cart');
          return response.json();
        })
        .then(function (cart) {
          state.existingEligibleSubtotal = (cart.items || []).filter(isMinimumEligibleItem).reduce(function (sum, item) {
            var linePrice = item.final_line_price == null ? item.original_line_price : item.final_line_price;
            return sum + Number(linePrice || 0);
          }, 0);
          render();
        })
        .catch(function () {
          state.existingEligibleSubtotal = 0;
          render();
        });
    }

    function render() {
      var summary = summaryFor(state.lines);
      refreshLengthOptions();
      renderLineImpacts(summary);
      renderSummaryLines(summary);
      setText('[data-bf-total-garlands]', String(summary.totalGarlands));
      setText('[data-bf-total-feet]', summary.totalFeet + ' ft');
      setText('[data-bf-base-price]', summary.basePrice ? money(summary.basePrice) : '-');
      setText('[data-bf-additional-count]', String(summary.additionalGarlandCount));
      setText('[data-bf-additional-total]', money(summary.additionalGarlandTotal));
      setText('[data-bf-savings]', summary.savings ? money(summary.savings) : '-');
      setText('[data-bf-total-price]', summary.subtotal ? money(summary.subtotal) : '$0.00');

      var additionalRow = root.querySelector('[data-bf-additional-row]');
      var baseRow = root.querySelector('[data-bf-base-row]');
      var savingsRow = root.querySelector('[data-bf-savings-row]');
      if (baseRow) baseRow.hidden = true;
      if (additionalRow) additionalRow.hidden = true;
      if (savingsRow) savingsRow.hidden = summary.savings === 0;

      var eligibleSubtotal = state.existingEligibleSubtotal + summary.subtotal;
      var minimumMet = eligibleSubtotal >= Number(config.minimumSubtotal);
      if (minimumNode) {
        minimumNode.hidden = !summary.subtotal || minimumMet;
        minimumNode.textContent = minimumMet || !summary.subtotal ? '' : 'Fresh products and garlands require a $149.95 minimum. Add ' + money(Number(config.minimumSubtotal) - eligibleSubtotal) + ' more to continue.';
      }
      if (limitNode) {
        limitNode.hidden = summary.totalFeet <= Number(config.maximumLength);
      }
      submitButton.disabled = !summary.allLinesValid || !summary.withinMaximum || !summary.priceRecord || !minimumMet || !validateDates(false);
    }

    function setText(selector, value) {
      var node = root.querySelector(selector);
      if (node) node.textContent = value;
    }

    function setStatus(message, success) {
      if (!statusNode) return;
      statusNode.textContent = message || '';
      statusNode.classList.toggle('is-success', Boolean(success));
    }

    function validateLines(showMessage) {
      var summary = summaryFor(state.lines);
      var invalid = state.lines.find(function (line) { return !validLine(line); });
      if (invalid) {
        if (showMessage) {
          setStatus('Select a whole-foot length from ' + config.minimumLength + ' to ' + config.maximumLength + ' feet for every garland.', false);
          var invalidNode = linesNode.querySelector('[data-bf-garland-line="' + invalid.id + '"] [data-bf-line-length]');
          if (invalidNode) invalidNode.focus();
        }
        return false;
      }
      if (!summary.withinMaximum || !summary.priceRecord) {
        if (showMessage) setStatus('For configurations over ' + config.maximumLength + ' total feet, please contact us for a custom quote.', false);
        return false;
      }
      return true;
    }

    function dateFromIso(value) {
      var parts = String(value || '').split('-').map(Number);
      return parts.length === 3 && parts.every(Number.isFinite) ? new Date(parts[0], parts[1] - 1, parts[2], 12) : null;
    }

    function iso(date) {
      return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
    }

    function addDays(date, amount) {
      var next = new Date(date);
      next.setDate(next.getDate() + amount);
      return next;
    }

    function monthStart(date) {
      return new Date(date.getFullYear(), date.getMonth(), 1, 12);
    }

    function sameDate(first, second) {
      return Boolean(first && second && iso(first) === iso(second));
    }

    var deliveryWeekdayLabels = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
    var deliveryMonthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    function friendlyDate(date) {
      var label = deliveryWeekdayLabels[date.getDay()] + ', ' + deliveryMonthLabels[date.getMonth()] + ' ' + date.getDate();
      if (date.getFullYear() !== new Date().getFullYear()) label += ', ' + date.getFullYear();
      return label;
    }

    function friendlyMonthYear(date) {
      return deliveryMonthLabels[date.getMonth()] + ' ' + date.getFullYear();
    }

    var federalHolidayCache = {};

    function observedFixedHoliday(year, month, day) {
      var holiday = new Date(year, month, day, 12);
      if (holiday.getDay() === 6) return addDays(holiday, -1);
      if (holiday.getDay() === 0) return addDays(holiday, 1);
      return holiday;
    }

    function nthWeekdayOfMonth(year, month, weekday, occurrence) {
      var date = new Date(year, month, 1, 12);
      date.setDate(1 + ((7 + weekday - date.getDay()) % 7) + ((occurrence - 1) * 7));
      return date;
    }

    function lastWeekdayOfMonth(year, month, weekday) {
      var date = new Date(year, month + 1, 0, 12);
      date.setDate(date.getDate() - ((7 + date.getDay() - weekday) % 7));
      return date;
    }

    function federalHolidaysForYear(year) {
      if (federalHolidayCache[year]) return federalHolidayCache[year];
      var holidays = {};
      function add(date) {
        holidays[iso(date)] = true;
      }
      for (var legalYear = year - 1; legalYear <= year + 1; legalYear += 1) {
        add(observedFixedHoliday(legalYear, 0, 1));
        add(nthWeekdayOfMonth(legalYear, 0, 1, 3));
        add(nthWeekdayOfMonth(legalYear, 1, 1, 3));
        add(lastWeekdayOfMonth(legalYear, 4, 1));
        add(observedFixedHoliday(legalYear, 5, 19));
        add(observedFixedHoliday(legalYear, 6, 4));
        add(nthWeekdayOfMonth(legalYear, 8, 1, 1));
        add(nthWeekdayOfMonth(legalYear, 9, 1, 2));
        add(observedFixedHoliday(legalYear, 10, 11));
        add(nthWeekdayOfMonth(legalYear, 10, 4, 4));
        add(observedFixedHoliday(legalYear, 11, 25));
      }
      federalHolidayCache[year] = holidays;
      return holidays;
    }

    function isFederalHoliday(date) {
      return Boolean(federalHolidaysForYear(date.getFullYear())[iso(date)]);
    }

    function isBusinessDay(date) {
      return date.getDay() >= 1 && date.getDay() <= 5 && !isFederalHoliday(date);
    }

    function isShipmentDay(date) {
      return isBusinessDay(date) && !isFederalHoliday(addDays(date, 1));
    }

    function isDeliveryDay(date) {
      return date.getDay() >= 2 && date.getDay() <= 6 && !isFederalHoliday(date) && isShipmentDay(addDays(date, -1));
    }

    function isRecommendedDeliveryDay(date) {
      return date.getDay() >= 2 && date.getDay() <= 4 && isDeliveryDay(date);
    }

    function nextBusinessDay(date) {
      var next = addDays(date, 1);
      while (!isBusinessDay(next)) next = addDays(next, 1);
      return next;
    }

    function previousBusinessDay(date) {
      var next = addDays(date, -1);
      while (!isBusinessDay(next)) next = addDays(next, -1);
      return next;
    }

    function subtractBusinessDays(date, amount) {
      var next = new Date(date);
      var remaining = amount;
      while (remaining > 0) {
        next = addDays(next, -1);
        if (isBusinessDay(next)) remaining -= 1;
      }
      return next;
    }

    function pacificNowParts() {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { values[part.type] = part.value; });
      return {
        date: new Date(Number(values.year), Number(values.month) - 1, Number(values.day), 12),
        hour: Number(values.hour),
        minute: Number(values.minute),
        second: Number(values.second)
      };
    }

    function earliestDeliveryDate() {
      var pacific = pacificNowParts();
      var currentSeconds = (pacific.hour * 3600) + (pacific.minute * 60) + pacific.second;
      var cutoffSeconds = Number(config.orderCutoffHourPacific || 14) * 3600;
      var shipmentDate = addDays(pacific.date, 1);
      while (true) {
        if (isShipmentDay(shipmentDate)) {
          var cutoffDay = previousBusinessDay(shipmentDate);
          if (pacific.date < cutoffDay || (sameDate(pacific.date, cutoffDay) && currentSeconds < cutoffSeconds)) {
            return addDays(shipmentDate, 1);
          }
        }
        shipmentDate = addDays(shipmentDate, 1);
      }
    }

    function millisecondsUntilNextCutoff() {
      var pacific = pacificNowParts();
      var currentSeconds = (pacific.hour * 3600) + (pacific.minute * 60) + pacific.second;
      var cutoffSeconds = Number(config.orderCutoffHourPacific || 14) * 3600;
      var daysUntilCutoff = 0;
      var cutoffDate = new Date(pacific.date);

      if (!isBusinessDay(cutoffDate) || currentSeconds >= cutoffSeconds) {
        do {
          cutoffDate = addDays(cutoffDate, 1);
          daysUntilCutoff += 1;
        } while (!isBusinessDay(cutoffDate));
      }

      return Math.max(250, (((daysUntilCutoff * 86400) + cutoffSeconds - currentSeconds) * 1000) + 250);
    }

    function recommendedDeliveryDate(eventDate) {
      var earliest = earliestDeliveryDate();
      if (!eventDate || eventDate < earliest) return null;
      var weekday = eventDate.getDay();
      var recommended;
      if (weekday === 1 || weekday === 2) {
        recommended = addDays(eventDate, -3);
      } else if (weekday === 3) {
        var tuesday = addDays(eventDate, -1);
        recommended = isDeliveryDay(tuesday) ? tuesday : addDays(eventDate, -4);
      } else {
        recommended = subtractBusinessDays(eventDate, 2);
      }
      while (recommended >= earliest && !isDeliveryDay(recommended)) recommended = addDays(recommended, -1);
      return recommended >= earliest && recommended <= eventDate ? recommended : null;
    }

    function validateDates(showMessage) {
      var delivery = dateFromIso(deliveryInput.value);
      var eventDate = dateFromIso(eventInput.value);
      var earliest = earliestDeliveryDate();
      var message = '';
      if (!eventDate) message = 'Select the event or use date.';
      else if (!delivery) message = 'Select the requested delivery date.';
      else if (delivery < earliest) message = 'Choose a later delivery date that allows production and overnight shipment.';
      else if (!isDeliveryDay(delivery)) message = 'Fresh garland delivery is available Tuesday through Saturday.';
      else if (delivery > eventDate) message = 'Delivery must be on or before the event or use date.';
      if (showMessage && message) setStatus(message, false);
      return !message;
    }

    function renderCalendar() {
      if (!calendarNode) return;
      var earliest = earliestDeliveryDate();
      var selected = dateFromIso(deliveryInput.value);
      var eventDate = dateFromIso(eventInput.value);
      var recommended = dateFromIso(state.recommendedDelivery);
      var display = state.calendarMonth || monthStart(selected || recommended || earliest);
      state.calendarMonth = display;
      var previousMonth = new Date(display.getFullYear(), display.getMonth() - 1, 1, 12);
      var nextMonth = new Date(display.getFullYear(), display.getMonth() + 1, 1, 12);
      var lastAllowed = eventDate || addDays(earliest, 550);
      var canGoPrevious = previousMonth >= monthStart(earliest);
      var canGoNext = nextMonth <= monthStart(lastAllowed);
      var firstWeekday = display.getDay();
      var daysInMonth = new Date(display.getFullYear(), display.getMonth() + 1, 0).getDate();
      var days = '';
      for (var blank = 0; blank < firstWeekday; blank += 1) days += '<span aria-hidden="true"></span>';
      for (var day = 1; day <= daysInMonth; day += 1) {
        var date = new Date(display.getFullYear(), display.getMonth(), day, 12);
        var disabled = date < earliest || !isDeliveryDay(date) || date > lastAllowed;
        var classes = ['bf-garland-calendar__day'];
        if (!isDeliveryDay(date)) classes.push('is-unavailable-weekday');
        if (sameDate(date, earliest)) classes.push('is-earliest');
        if (sameDate(date, recommended)) classes.push('is-recommended');
        if (sameDate(date, selected)) classes.push('is-selected');
        days += '<button type="button" class="' + classes.join(' ') + '" data-bf-calendar-date="' + iso(date) + '" aria-label="' + friendlyDate(date) + '"' + (disabled ? ' disabled' : '') + '>' + day + '</button>';
      }
      calendarNode.innerHTML =
        '<div class="bf-garland-calendar__header">' +
          '<button type="button" class="bf-garland-calendar__nav" data-bf-calendar-nav="previous" aria-label="Previous month"' + (canGoPrevious ? '' : ' disabled') + '>&lsaquo;</button>' +
          '<strong>' + friendlyMonthYear(display) + '</strong>' +
          '<button type="button" class="bf-garland-calendar__nav" data-bf-calendar-nav="next" aria-label="Next month"' + (canGoNext ? '' : ' disabled') + '>&rsaquo;</button>' +
        '</div>' +
        '<div class="bf-garland-calendar__weekdays" aria-hidden="true"><span class="is-unavailable">Sun</span><span class="is-unavailable">Mon</span><span>Tues</span><span>Wed</span><span>Thurs</span><span>Fri</span><span>Sat</span></div>' +
        '<div class="bf-garland-calendar__days">' + days + '</div>' +
        '<div class="bf-garland-calendar__legend"><span class="is-earliest"><i></i> Earliest available</span><span class="is-recommended"><i></i> Recommended</span><span class="is-selected"><i></i> Selected</span><span class="is-unavailable"><i></i> No delivery</span></div>';
      earliestButton.classList.toggle('is-selected', sameDate(selected, earliest));
      recommendationButton.classList.toggle('is-selected', sameDate(selected, recommended));
    }

    function renderDateSuggestions(focusRecommendedMonth) {
      var earliest = earliestDeliveryDate();
      var eventDate = dateFromIso(eventInput.value);
      var recommended = eventDate ? recommendedDeliveryDate(eventDate) : null;
      earliestLabel.textContent = friendlyDate(earliest);
      if (deliveryHelp) {
        deliveryHelp.textContent = 'Fresh products ship Monday through Friday by FedEx 1-Day shipping (included in pricing). Earliest available delivery: ' + friendlyDate(earliest) + '. Garland order cut-off time is 2pm PST one business day before shipment.';
      }
      state.recommendedDelivery = recommended ? iso(recommended) : '';
      var recommendationAvailable = Boolean(recommended && recommended >= earliest && recommended <= eventDate && isDeliveryDay(recommended));
      recommendationButton.disabled = !recommendationAvailable;
      recommendationLabel.textContent = recommendationAvailable ? friendlyDate(recommended) : (eventDate ? 'No recommended date before event' : 'Select event date');
      if (recommendationAvailable) {
        var selectedDelivery = dateFromIso(deliveryInput.value);
        if (!state.deliveryTouched || !selectedDelivery || selectedDelivery > eventDate || selectedDelivery < earliest) {
          deliveryInput.value = state.recommendedDelivery;
        }
        if (focusRecommendedMonth) state.calendarMonth = monthStart(recommended);
      } else {
        if (!state.deliveryTouched) deliveryInput.value = "";
        if (focusRecommendedMonth) state.calendarMonth = monthStart(earliest);
      }
      deliveryInput.min = iso(earliest);
      if (eventDate) deliveryInput.max = iso(eventDate);
      else deliveryInput.removeAttribute('max');
      renderCalendar();
      render();
    }

    function refreshEarliestAvailability() {
      var earliest = earliestDeliveryDate();
      var selected = dateFromIso(deliveryInput.value);
      if (selected && selected < earliest) {
        deliveryInput.value = '';
        state.deliveryTouched = false;
      }
      if (state.calendarMonth && state.calendarMonth < monthStart(earliest)) {
        state.calendarMonth = monthStart(earliest);
      }
      renderDateSuggestions(false);
    }

    function scheduleCutoffRefresh() {
      if (state.cutoffTimer) window.clearTimeout(state.cutoffTimer);
      state.cutoffTimer = window.setTimeout(function () {
        refreshEarliestAvailability();
        scheduleCutoffRefresh();
      }, Math.min(millisecondsUntilNextCutoff(), 21600000));
    }

    linesNode.addEventListener('change', function (event) {
      var line = readLine(event.target);
      if (!line) return;
      if (event.target.matches('[data-bf-line-style]')) {
        line.handle = event.target.value;
        updateLineImage(line, event.target.closest('[data-bf-garland-line]'));
      }
      if (event.target.matches('[data-bf-line-length]')) line.length = Math.floor(Number(event.target.value) || 0);
      if (event.target.matches('[data-bf-line-pieces]')) {
        line.pieces = Math.max(1, Math.min(99, Math.floor(Number(event.target.value) || 1)));
        event.target.value = String(line.pieces);
      }
      setStatus('', false);
      render();
    });

    linesNode.addEventListener('input', function (event) {
      if (!event.target.matches('[data-bf-line-pieces]')) return;
      var line = readLine(event.target);
      if (!line) return;
      line.pieces = Math.max(1, Math.min(99, Math.floor(Number(event.target.value) || 1)));
      render();
    });

    linesNode.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bf-remove-line]');
      if (!button) return;
      var line = readLine(button);
      if (!line) return;
      state.lines = state.lines.filter(function (entry) { return entry.id !== line.id; });
      button.closest('[data-bf-garland-line]').remove();
      renumberLines();
      setStatus('', false);
      render();
    });

    addButton.addEventListener('click', function () {
      addLine({ handle: requestedGarlandHandle() || config.styles[0].handle });
    });

    eventInput.min = iso(earliestDeliveryDate());
    eventInput.addEventListener('change', function () {
      state.deliveryTouched = false;
      renderDateSuggestions(true);
    });
    deliveryInput.addEventListener('change', function () {
      state.deliveryTouched = true;
      var selected = dateFromIso(deliveryInput.value);
      if (selected) state.calendarMonth = monthStart(selected);
      renderCalendar();
      render();
    });
    earliestButton.addEventListener('click', function () {
      var earliest = earliestDeliveryDate();
      deliveryInput.value = iso(earliest);
      state.deliveryTouched = true;
      state.calendarMonth = monthStart(earliest);
      renderDateSuggestions(false);
    });
    recommendationButton.addEventListener('click', function () {
      if (!state.recommendedDelivery) return;
      deliveryInput.value = state.recommendedDelivery;
      state.deliveryTouched = true;
      state.calendarMonth = monthStart(dateFromIso(state.recommendedDelivery));
      renderDateSuggestions(false);
    });
    calendarNode.addEventListener('click', function (event) {
      var nav = event.target.closest('[data-bf-calendar-nav]');
      if (nav && !nav.disabled) {
        state.calendarMonth = new Date(state.calendarMonth.getFullYear(), state.calendarMonth.getMonth() + (nav.getAttribute('data-bf-calendar-nav') === 'next' ? 1 : -1), 1, 12);
        renderCalendar();
        return;
      }
      var day = event.target.closest('[data-bf-calendar-date]');
      if (!day || day.disabled) return;
      deliveryInput.value = day.getAttribute('data-bf-calendar-date');
      state.deliveryTouched = true;
      renderCalendar();
      render();
    });

    submitButton.addEventListener('click', function () {
      if (!validateLines(true) || !validateDates(true)) {
        render();
        return;
      }
      var summary = summaryFor(state.lines);
      if (state.existingEligibleSubtotal + summary.subtotal < Number(config.minimumSubtotal)) {
        render();
        return;
      }
      var groupId = 'BF-GAR-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
      var properties = {
        'Total combined length': summary.totalFeet + ' ft',
        'Total garlands': String(summary.totalGarlands),
        'Requested delivery date': deliveryInput.value,
        'Event or use date': eventInput.value,
        '_bf_custom_garland': 'true',
        '_bf_builder_group': groupId,
        '_bf_source_context': context
      };
      state.lines.forEach(function (line, index) {
        var style = styleByHandle(line.handle);
        properties['Garland ' + (index + 1)] = (style ? style.title : 'Fresh garland') + ' - ' + line.length + ' ft x ' + line.pieces;
      });
      if (summary.savings > 0) properties['Combined-garland savings'] = money(summary.savings);
      if (state.lines.some(function (line) { return line.length > 50; })) {
        properties.Preparation = 'Lengths over 50 ft are prepared in 50-ft sections';
      }
      properties['_bf_pricing_policy'] = summary.totalGarlands > 1 ? 'multi-v1' : 'single-v2';

      var items = [{
        id: String(summary.priceRecord.variantId),
        quantity: 1,
        properties: properties
      }];
      submitButton.disabled = true;
      submitButton.classList.add('is-loading');
      setStatus('Adding your fresh garlands...', false);
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return response.text().then(function (body) {
          var payload = {};
          try {
            payload = JSON.parse(body);
          } catch (parseError) {
            if (!response.ok) throw new Error('We could not add the garlands right now. Please wait a moment and try again.');
            throw new Error('The cart returned an unexpected response. Please try again.');
          }
          if (!response.ok) throw new Error(payload.description || payload.message || 'Could not add the configuration.');
          return payload;
        });
      }).then(function (payload) {
        setStatus('Fresh garlands added to cart.', true);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: payload, addToCartBtn: submitButton } }));
        return loadExistingEligibleSubtotal();
      }).catch(function (error) {
        setStatus(error.message || 'Could not add the configuration. Please try again.', false);
      }).finally(function () {
        submitButton.classList.remove('is-loading');
        render();
      });
    });

    state.calendarMonth = monthStart(earliestDeliveryDate());
    addLine({
      handle: requestedGarlandHandle() || config.styles[0].handle,
      locked: context === 'product'
    });
    renderDateSuggestions(false);
    scheduleCutoffRefresh();
    window.addEventListener('focus', function () {
      refreshEarliestAvailability();
      scheduleCutoffRefresh();
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        refreshEarliestAvailability();
        scheduleCutoffRefresh();
      }
    });
    loadExistingEligibleSubtotal();
  }

  function handleGroupedRemoval(event) {
    var button = event.target.closest('[data-bf-remove-garland-group]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var groupId = button.getAttribute('data-bf-remove-garland-group');
    if (!groupId || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Removing...';
    var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(rootUrl + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not read cart.');
        return response.json();
      })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (item.properties && String(item.properties._bf_builder_group || '') === groupId) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) throw new Error('Garland configuration was not found.');
        return fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not remove garland configuration.');
        return response.json();
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        window.location.href = rootUrl + 'cart';
      });
  }
}());
